import { Drawer } from "@circleco/compass/components/Drawer";
import { IconButton } from "@circleco/compass/components/IconButton";
import { Typography } from "@circleco/compass/components/Typography";

import { t } from "@/i18n-js/instance";

interface ReactionDrawerHeaderProps {
  title: string;
}

export const ReactionDrawerHeader = ({ title }: ReactionDrawerHeaderProps) => (
  <header className="bg-primary sticky -top-px z-10 -mx-4 flex items-center gap-3 px-5 pb-4">
    <Typography variant="heading-lg" className="min-w-0 flex-1" truncate>
      {title}
    </Typography>
    <Drawer.Close>
      <IconButton
        variant="ghost"
        size="sm"
        icon="cross"
        aria-label={t("close")}
      />
    </Drawer.Close>
  </header>
);
